export const SERVER_MODAL_ICON = {
  VIDEO: "video",
  FORM: "form",
  LIGHTBULB: "lightbulb",
  WARNING: "warning",
  HEART: "heart",
  TRACKER: "tracker",
  LAB: "lab",
  PILLS: "pills",
  CALENDAR: "calendar",
  ADDRESS: "address",
  PRESCRIPTION: "prescription",
  CREDIT_CARD: "credit-card",
  UNSUBSCRIBE: "unsubscribe",
  USER: "user",
} as const;
